import { AnalysisLinks } from "app/analysis/AnalysisLinks/AnalysisLinks";
import { AnalysisOverview } from "app/analysis/AnalysisOverview/AnalysisOverview";
import { AnalysisObject } from "app/analysis/interfaces";
import { Box } from "app/layout/Box/Box";

import React from "react";
import { FinanceKnowledgeContainer } from "app/financeKnowledge/FinanceKnowledgeContainer/FinanceKnowledgeContainer";
import { SectionHeader } from "app/layout/SectionHeader/SectionHeader/SectionHeader";

export interface Props extends AnalysisObject {
    /**
     * ISO currency code of the target values currency
     */
    currency: string;
    /**
     * Appends a string to the block headline
     */
    headlineAddon?: string;
}

/**
 * The analysis content block can be used in pages. It will use sub-components to render a visual analysis overview
 * as well as a list of links to analysis detail pages.
 */
export const AnalysisContentBlock = ({
    headlineAddon,
    buy,
    hold,
    sell,
    recommendation,
    targetValue,
    currency,
    differencePercent,
    items
}: Props) => (
    <Box section className="analysis">
        <SectionHeader headline={`Analysen${headlineAddon}`} />
        <FinanceKnowledgeContainer knowledgeKey="analysesExplained" />
        <AnalysisOverview
            buy={buy}
            hold={hold}
            sell={sell}
            currency={currency}
            recommendation={recommendation}
            targetValue={targetValue}
            differencePercent={differencePercent}
        />
        <AnalysisLinks items={items} />
    </Box>
);
